<template>
  <v-container v-if="!containerInitLoading && machineType" fluid style="height: inherit">
    <v-row align="stretch" style="height: inherit;">
      <v-col>
        <MachineTypeDetails :machineType="machineType" @Set="value => { machineType = value }">
        </MachineTypeDetails>
      </v-col>

      <v-divider vertical style="z-index: 1;" />

      <v-col style="background-color: rgb(248, 248, 248) !important;">
        <MachineTypeDefaultServiceAgreementDetails :machineType="machineType" @Set="value => { machineType = value }">
        </MachineTypeDefaultServiceAgreementDetails>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import MachineTypeDetails from "./MachineTypeDetails.vue";
import MachineTypeDefaultServiceAgreementDetails from "./MachineTypeDefaultServiceAgreementDetails.vue";

export default {
  name: "ViewMachineTypeInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    MachineTypeDetails,
    MachineTypeDefaultServiceAgreementDetails,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {

  },

  computed: {
    machineType: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

  },

  watch: {

  },
};
</script>


<style lang='scss'></style>